<template>
  <section class="ui-loading">
    <div class="ui-loading__container">
      <img
      v-for="(c, i) in 4"
      :key="i"
      src="/img/misc/farfalla.gif"
      :class="['ui-loading__butterfly', `ui-loading__butterfly--${i}`]"
    >
    </div>
  </section>
</template>

<script>
export default {
  name: 'UIloading',
};
</script>

<style lang="scss" scoped>
.ui-loading {
  position: relative;

  &__container {
    display: none;

    @include mq($until: ipadP) {
      display: block;
    }
  }

  &__butterfly {
    position: absolute;

    &--0 {
      left: 60vw;
      top: 30vh;
      transform: scale(0.2) rotate(10deg);
    }
    &--1 {
      left: 40vw;
      top: 50vh;
      transform: scale(0.2) rotate(-10deg);
    }
    &--2 {
      left: 75vw;
      top: 70vh;
      transform: scale(0.2) rotate(10deg);
    }
    &--3 {
      left: 10vw;
      top: 85vh;
      transform: scale(0.2) rotate(10deg);
    }
  }
}
</style>
